export const enum ClientType {
  Base = "base",
  Tenant = "tenant",
  Portfolio = "portfolio",
}
